import React from 'react';

import { connect } from 'react-redux';

import { Button } from '@nerdwallet/currency';

import AuthModal from '../../../containers/auth-modal';
import GoalCta from '../../goal-cta/goal-cta';

export type CtaProps = {
  identity: Record<string, any>;
};

const notSignedInCta = (
  <GoalCta subtitle="Good news. Nerdwallet can help you with your goal of buying a home">
    <AuthModal driverLocation={null}>
      <Button primary>See how</Button>
    </AuthModal>
  </GoalCta>
);

const signedInCta = (
  <GoalCta
    subtitle="Interested in buying? See how much house you can afford with our affordability calculator"
    actionText="Get started"
    link="/mortgages/how-much-house-can-i-afford"
  />
);

export const Cta = ({ identity }: CtaProps): JSX.Element => {
  return identity?.isSignedIn ? signedInCta : notSignedInCta;
};
const mapStateToProps = (state) => ({
  identity: state?.identity,
});

export default connect(mapStateToProps)(Cta);
